module.exports = cptable;


//////////////////
// WEBPACK FOOTER
// external "cptable"
// module id = e6XX
// module chunks = 1